---
de:
  notification_system:
    instant_sender:
      associated_event: Zugehöriges Ereignis
      capacity_used: Verwendete Kapazität
      current_deviation: Aktuelle Abweichung
      current_energy: Aktuelle Energie
      deviation_value: "%{deviation}%"
      energy_mwh: "%{energy} MWh"
      event_component: Komponente
      event_started: Gestartet
      event_status: Status
      maximum_capacity: Maximale Kapazität
      optimization_initiated: Die Produktionsoptimierung wurde eingeleitet und die Markteinreichung wird folgen.
      percentage: "%{percentage}%"
      reservoir_energy_status: Speicherenergie-Status
      threshold_setting: Schwellenwert-Einstellung
      threshold_value: "±%{threshold}%"
      toast_title: InstantSender-Auslösung bei %{power_plant_name}
      trigger_time: Auslösezeitpunkt
      trigger_type: Auslösertyp
      trigger_types:
        manual: Manueller Auslöser
        other: Sonstiges
        water_level_high: Hoher Wasserstand
        water_level_low: Niedriger Wasserstand
      triggered_for: InstantSender wurde für %{power_plant_name} ausgelöst
      view_details: Details im Portal-Produktionssimulationsplan anzeigen.
      water_level: Wasserstand
      water_level_masl: "%{level} m ü. M."
